import { render, staticRenderFns } from "./ComprometimentosSemRegistroPagamento.vue?vue&type=template&id=33c12501"
import script from "./ComprometimentosSemRegistroPagamento.vue?vue&type=script&lang=js"
export * from "./ComprometimentosSemRegistroPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports